import { SHARE_SUCCESS } from './types';

export default {
    [SHARE_SUCCESS](state, payload) {
        state.share = payload;
    },
};



// WEBPACK FOOTER //
// ./src/store/share/mutations.js